var map = {
	"./aiSecurity/en.json": [
		3636,
		53
	],
	"./dataLeakage/en.json": [
		3637,
		56
	],
	"./ppd/en.json": [
		3638,
		59
	],
	"./ransomware/en.json": [
		3639,
		62
	],
	"./socialMedia/en.json": [
		3640,
		65
	],
	"./whatsApp/en.json": [
		3641,
		68
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1202;
module.exports = webpackAsyncContext;